import SchoolProfile from './schoolProfile'
export default SchoolProfile
